<template>
  <div>
    <div class="row mt-4">
      <div class="col-sm-6">
        <h5 class="mb-3">{{ $t('marketplace.rma_product.filter_option') }}</h5>
        <b-form v-if="show">
          <b-form-fieldset
            :label="$t('marketplace.rma_product.imei_code')"
            :label-cols="3"
            :horizontal="true">
            <b-form-input type="text" v-model="filter.imei_code" :placeholder="$t('marketplace.rma_product.please_enter_imei_code')"></b-form-input>
          </b-form-fieldset>
          <b-form-fieldset
            :label="$t('marketplace.rma_product.platform_order_id')"
            :label-cols="3"
            :horizontal="true">
            <b-form-input type="text" v-model="filter.platform_order_id" :placeholder="$t('marketplace.rma_product.please_enter_platform_order_id')"></b-form-input>
          </b-form-fieldset>
          <b-button type="button" size="sm" variant="primary" @click="onSearchForm"><i class="fa fa-search"></i> {{ $t('marketplace.rma_product.search') }}</b-button>
          <b-button type="reset" size="sm" variant="danger ml-1" @click="onReset"><i class="fa fa-ban"></i> {{ $t('marketplace.rma_product.reset') }}</b-button>
        </b-form>
      </div><!--col-->
    </div>
    <CModal
      title="Order Item List"
      :show.sync="modalItemListShow"
      color="primary"
      size="xl"
    >
      <order-item-list :orderItems="orderItems" :selectedId="selectedItemId" :addRmaProduct="handleItemListCallback"></order-item-list>
      <div slot="footer"></div>
    </CModal>
    <CModal
      title="Add Rma Product"
      :show.sync="modalRmaProductShow"
      color="primary"
      size="xl"
    >
      <add-rma-product-form  :orderItem="selectedOrderItem" :callback="handleCreateProductCallback" ></add-rma-product-form>
      <div slot="footer"></div>
    </CModal>
  </div>
</template>

<script>
import AddRmaProductForm from './AddRmaProductForm.vue'
import OrderItemList from './OrderItemList.vue'

export default {
  name: 'RmaProductFilters',
  components: {
    AddRmaProductForm,
    OrderItemList
  },
  props: {
    fetchRmaLatestProducts: {
      type: Function
    }
  },
  data () {
    return {
      filter: {
        platform_order_id: "",
        imei_code: "",
      },
      selectedOrderItem: null,
      selectedItemId: null,
      orderItems: [],
      show: true,
      modalRmaProductShow: false,
      modalItemListShow: false,
    }
  },
  methods: {
    onReset () {
      // evt.preventDefault()
      this.filter.platform_order_id = ''
      this.filter.imei_code = ''
      this.show = false
      this.$nextTick(() => { this.show = true })
    },
    handleCreateProductCallback() {
      this.modalRmaProductShow = false
      // show index page latest add RMA product
      this.fetchRmaLatestProducts({
        platform_order_id: this.filter.platform_order_id,
        imei_code: this.filter.imei_code,
      });
    },
    handleItemListCallback(item) {
      this.addRmaProduct(item)
      this.modalItemListShow = false
    },
    addRmaProduct(item) {
      this.selectedOrderItem = item
      this.modalRmaProductShow = true
    },
    showOrderItemList(items) {
      this.orderItems = items
      this.modalItemListShow = true
      this.selectedItemId = null
    },
    onSearchForm(){
      this.axios.get('/marketplace/rma-product/platform-order-item', {
        params: {
          platform_order_id: this.filter.platform_order_id,
          imei_code: this.filter.imei_code,
        }
      }).then(response => {
        if(response.data.length === 0) {
          this.$swal({
            title: 'No found order item',
            icon: 'warning'
          })
        } else if (response.data.length > 1) {
          //show modal
          console.log(response.data)
          this.showOrderItemList(response.data)
        } else {
          response.data.forEach((item) => {
            this.addRmaProduct(item)
          })
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
